import { Controller } from "@hotwired/stimulus"

// Simple list filter controller
// Usage: Add data-controller="list-filter" to container
//        Add data-list-filter-target="input" to the search input
//        Add data-list-filter-target="item" and data-filter-text="searchable text" to each item
export default class extends Controller {
  static targets = ["input", "item", "list"]

  connect() {
    // Bind the filter method to ensure proper context
    this.boundFilter = this.filter.bind(this)
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener('input', this.boundFilter)
    }
  }

  disconnect() {
    if (this.hasInputTarget && this.boundFilter) {
      this.inputTarget.removeEventListener('input', this.boundFilter)
    }
  }

  filter() {
    if (!this.hasInputTarget) return
    
    const query = this.inputTarget.value.toLowerCase().trim()

    this.itemTargets.forEach(item => {
      const text = (item.dataset.filterText || item.textContent || '').toLowerCase()
      const matches = query === "" || text.includes(query)
      item.style.display = matches ? "" : "none"
    })
  }

  // Clear filter and show all items
  clear() {
    if (!this.hasInputTarget) return
    
    this.inputTarget.value = ""
    this.itemTargets.forEach(item => {
      item.style.display = ""
    })
  }
}
